import React from 'react';
import { CommentGroup } from '../../model/CommentGroup';
import { Link } from 'react-router-dom';
import { toSydneyDate } from '../../util/util';
import styled from 'styled-components';


interface IProps{
    commentGroup:CommentGroup
}

const Wrapper = styled.div`
.unconfirmed {
    color: #fff;
    background-color: red;
    padding: 2px 10px;
}

`;

const CommentGroupItem: React.FC<IProps>= (props:IProps) => {


    return <Wrapper>

        <p>{props.commentGroup.announcementHeadline}</p>
        <table>
            <tbody>
            {props.commentGroup.comments.map((x,i)=>{
                return <tr key={i}>
                    <td><Link to={`/AnnouncementCommentResponse/${x.announcementCommentEventGuid}`}>[Edit]</Link></td>
                    <td>{toSydneyDate(x.date)}</td>
                    <td>{x.name} {x.unconfirmed && <span className='unconfirmed'>Unconfirmed</span> }  </td>
                    <td>{x.comment}</td>
                    <td>{ !!x.responses.length && x.responses[0].comment}</td>

                     </tr>
            })}
            </tbody>
            
        </table>

    </Wrapper>
}

export default CommentGroupItem